<script setup>
import Button from 'primevue/button'

const props = defineProps({
    label:   { type: String, required: true },
    field:   { type: String, required: true },
    sortBy:  { type: String, default: '' },
    sortDir: { type: String, default: 'desc' },
    align:   { type: String, default: 'left' },
})

const emit = defineEmits(['sort'])
</script>

<template>
    <Button
        text
        size="small"
        :class="[
            '!text-[13px] !font-medium !gap-1 !px-0',
            align === 'right' ? 'ml-auto' : '',
            sortBy === field
                ? '!text-blue-600 dark:!text-blue-400'
                : '!text-neutral-500 dark:!text-neutral-400 hover:!text-neutral-700 dark:hover:!text-neutral-200',
        ]"
        @click="emit('sort', field)"
    >
        {{ label }}
        <i v-if="sortBy === field" class="!text-[13px]" :class="sortDir === 'asc' ? 'pi pi-arrow-up' : 'pi pi-arrow-down'" />
    </Button>
</template>
